import { create } from 'zustand'
import { Toast, type ToastVariant } from '@/components/common/Toast'

// -------------------------------------------------------
// Toast globale imperativo.
// Richiamabile da QUALSIASI punto (anche fuori da React, es. QueryClient):
//   import { toast } from '@/lib/toast'
//   toast.error('Operazione fallita')
// -------------------------------------------------------

interface ToastItem {
  id: string
  title: string
  description?: string
  variant: ToastVariant
  duration?: number
}

interface ToastStore {
  items: ToastItem[]
  push: (t: Omit<ToastItem, 'id'>) => void
  remove: (id: string) => void
}

let counter = 0

export const useToastStore = create<ToastStore>((set) => ({
  items: [],
  push: (t) =>
    set((s) => ({
      // max 5 toast visibili contemporaneamente
      items: [...s.items.slice(-4), { id: `toast-${++counter}-${Date.now()}`, ...t }],
    })),
  remove: (id) => set((s) => ({ items: s.items.filter((x) => x.id !== id) })),
}))

function show(variant: ToastVariant, title: string, description?: string) {
  useToastStore.getState().push(
    description !== undefined ? { title, description, variant } : { title, variant }
  )
}

export const toast = {
  success: (title: string, description?: string) => show('success', title, description),
  error: (title: string, description?: string) => show('error', title, description),
  warning: (title: string, description?: string) => show('warning', title, description),
  info: (title: string, description?: string) => show('info', title, description),
}

/** Monta una sola volta a livello app (vedi main.tsx). */
export function ToastHost() {
  const items = useToastStore((s) => s.items)
  const remove = useToastStore((s) => s.remove)
  return (
    <>
      {items.map((t) => (
        <Toast
          key={t.id}
          open
          onOpenChange={(open) => {
            if (!open) remove(t.id)
          }}
          title={t.title}
          variant={t.variant}
          duration={t.duration ?? 4500}
          {...(t.description !== undefined ? { description: t.description } : {})}
        />
      ))}
    </>
  )
}
